import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-default/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/css/theme/index.css'

//import './assets/theme/theme-green/index.css'
import VueRouter from 'vue-router'
import store from './store'
import Vuex from 'vuex'

import routes from './routes'

import 'font-awesome/css/font-awesome.min.css'
import './assets/icon-font/iconfont.css'

import axios from 'axios' //引入axios
import SlideVerify from './lib/index'

import vRegion from 'v-region'

import moment from 'moment';

Vue.prototype.$moment = moment;

Vue.use(vRegion, {  })

Vue.config.productionTip = false
Vue.use(SlideVerify)

Vue.prototype.$ajax=axios //修改Vue的原型属性


Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)

// 图像查看器
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { zIndex: 9999, "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

console.log('process.env==', process.env.NODE_ENV)
let env = process.env.NODE_ENV
//NProgress.configure({ showSpinner: false });
let base = (function() {
    let path = location.pathname;

    if(/^\/authorizion/.test(path)) {
      return '/authorizion/';
    }

    if(env ==='test' &&  /^\/dnnCloud\/exchange/.test(path)) {
      console.log("dnnCloud/exchange/")
      return '/dnnCloud/exchange';
    }
    return '/';
  })();

if(sessionStorage.getItem('token')){
  store.commit('set__token',sessionStorage.getItem('token'))
}
const router = new VueRouter({
  mode:'history',  
  base: base,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
      if (store.state.token) {  // 通过vuex state获取当前的token是否存在
          next();
      }else {
          next({
              path: '/loginAdmin',
              query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
          })
      }
  }
  else {
      next();
  }
})

//router.afterEach(transition => {
//NProgress.done();
//});

new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js